module.exports = __webpack_public_path__ + "images/emoji/broken_heart.98d1cffddd553c2e1c7a.png";